module.exports = __webpack_public_path__ + "static/media/painter2.f93f7ac0.wav";